import { NewsWidget, WidgetHost } from '@/core/widgets/export';
import React from 'react';
import { RouteObject } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCrosshairs } from '@fortawesome/free-solid-svg-icons';
import { Permissions } from '@/core/permissions/export';
import TrumpTrackerScroller from '@/modules/market-signals/components/trump-tracker/trump-tracker-scroller';

export class TrumpTrackerWidget implements NewsWidget {
  get defaultRoute(): string {
    return '';
  }

  get defaultTitle(): string {
    return 'TrumpTracker';
  }

  async hasPermission(permissions: string[]): Promise<boolean> {
    return !this.shouldHideToUser(permissions);
  }

  shouldHideToUser(permissions: string[]): boolean {
    return !permissions.includes(Permissions.ALPHA_ACCESS);
  }

  headerActions({ children }: { children?: React.ReactNode }): JSX.Element {
    return <>{children}</>;
  }

  get headerPanel(): JSX.Element {
    return (
      <span className={'text-warning'}>
        <FontAwesomeIcon icon={faCrosshairs} /> TrumpTracker
      </span>
    );
  }

  get id(): string {
    return 'trumptracker';
  }

  initialize(host: WidgetHost): void {}

  get routes(): RouteObject[] {
    return [
      {
        path: '/',
        element: <TrumpTrackerScroller />,
      },
    ];
  }

  get shortTitle(): JSX.Element {
    return this.headerPanel;
  }
}
